import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a hash (e.g. /stay#cottages), scroll to that section.
    // The target page may still be rendering, so retry for a short while.
    if (hash) {
      const id = hash.replace("#", "");
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempts < 25) {
          attempts++;
          setTimeout(tryScroll, 60);
        }
      };
      tryScroll();
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth"
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
